import cloneContextReducer from "@/components/CloneView/state/cloneContextReducer";
import { configureStore } from "@reduxjs/toolkit";

import cloneProgressReducer from "../components/CloneProgress/state/cloneProgressReducer";
import mondaySearchReducer from "../components/QuickSearch/state/mondaySearchReducer";

const reducer = {
  cloneProgress: cloneProgressReducer,
  mondaySearch: mondaySearchReducer,
  cloneContext: cloneContextReducer,
};

const devTools = process.env.NODE_ENV === "development";

export const store = configureStore({ reducer, devTools });

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
